import { Paper, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface SettingsSectionProps {
  id: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const SettingsSection = ({ id, title, subtitle, children }: SettingsSectionProps) => {
  const theme = useTheme();

  return (
    <Paper
      id={id}
      variant="outlined"
      sx={{
        p: 3,
        mb: 3,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
        scrollMarginTop: '80px',
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ color: theme.palette.text.primary }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      <Box>{children}</Box>
    </Paper>
  );
};
